import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';

export const LINK_MODAL_ID = `${Decoration_Type.LINK}.modal`;
